export function resumeMemberSignIn(token: string) {
  window.location.assign(`/oauth/authorize?resume=${encodeURIComponent(token)}`)
}
